import Decimal from 'decimal.js';
import { Numeric } from '@/lib/types/common';

export function calculateSharesQuantity(amountUsd: Numeric, priceUsd: Numeric): Decimal {
  const amount = new Decimal(amountUsd);
  const price = new Decimal(priceUsd);

  return amount.div(price);
}
